@if (filter$ | async; as filterNavigation) {
<div>
  <div class="filter-panel now-shopping-navigation">
    <h3>{{ 'product.listing.sidenav.nowshopping.title' | translate }}</h3>
    @for (filter of getActiveFilters(filterNavigation); track filter) {
    <div class="selected-filter-set">
      @if (filter.facets.length) {
      <h4>{{ filter.name }}</h4>
      } @for (facet of filter.facets; track facet) {
      <div>
        @if (facet.selected) {
        <div class="selected-filter-item">
          {{ facet.displayName }}
          <span (click)="applyFilter({ searchParameter: facet.searchParameter })">
            <fa-icon [icon]="['fas', 'times']" class="filter-clear" />
          </span>
        </div>
        }
      </div>
      }
    </div>
    }
  </div>
</div>
}
